var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-select', {
    staticClass: "language-select pt-3",
    attrs: {
      "dense": "",
      "outlined": "",
      "items": _vm.portalLanguages,
      "item-text": "description",
      "item-value": "key",
      "label": _vm.$t('profile.language')
    },
    on: {
      "change": _vm.updateLanguage
    },
    model: {
      value: _vm.form.lang,
      callback: function ($$v) {
        _vm.$set(_vm.form, "lang", $$v);
      },
      expression: "form.lang"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }